import { createContext } from 'react';

const commentaryContext = createContext();

export default commentaryContext;